export const UPDATE = "meetings/UPDATE";
export const APPEND = "meetings/APPEND";
export const UPDATE_ONE = "meetings/UPDATE_ONE";
export const DESTROY = "meetings/DESTROY";
export const LOADING = "meetings/LOADING";
